import React, {Component} from 'react';
import {compose} from "redux";
import {withRouter} from "react-router";
import {connect} from "react-redux";
import SummaryChart from "../SummaryChart";
import {getPunchStatusReport} from "../../../actions/reports";
import {buildSummaryChartData} from "../../../projections";
import * as PropTypes from "prop-types";
import {subdocumentStatusReportSelector} from "../selectors";

class PunchListSummary extends Component {
  componentDidMount() {
    const { onMount } = this.props;
    if (onMount) onMount();
  }

  render() {
    const { summary, title, onClick } = this.props;
    const chartData = buildSummaryChartData(summary);
    return (
      <SummaryChart
        title={title}
        data={chartData}
        onClick={onClick}
      />
    );
  }
}
// eslint-disable-next-line no-undef

PunchListSummary.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func,
};

export default compose(
  withRouter,
  connect(
    (state, props) => ({
      summary: subdocumentStatusReportSelector(state, { path: 'punches', code: 'punchlistitemstatus' })
    }),
    (dispatch, props) => ({
      onMount: () => dispatch(getPunchStatusReport({id: props.match.params.id}))
    })
  )
)(PunchListSummary);



// WEBPACK FOOTER //
// ./src/components/Projects/PunchList/PunchListSummary.js